import { Pause, Play } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";

interface PlaybackControlsProps {
  isPlaying: boolean;
  onPlay: () => void;
  onPause: () => void;
}

export default function PlaybackControls({
  isPlaying,
  onPlay,
  onPause,
}: PlaybackControlsProps) {
  return (
    <Button
      size="sm"
      intent="iconOnly"
      variant="default-purple"
      onClick={isPlaying ? onPause : onPlay}
      aria-label={isPlaying ? "Pause playback" : "Play recording"}
    >
      {isPlaying ? <Pause weight="fill" /> : <Play weight="fill" />}
    </Button>
  );
}
